import React, { useCallback } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { RefreshActions } from '../state/refresh'
import { useDispatch } from 'react-redux'
import { useRequests } from '../requests/useRequests'

interface DeleteGroupDialogProps {
  ids: number[]
  handleClose: (b: boolean) => void
}

const DeleteUserDialog = ({
  ids,
  handleClose
}: DeleteGroupDialogProps): JSX.Element => {
  const dispatch = useDispatch()
  const requestMaker = useRequests()

  const onSubmit = useCallback(async () => {
    try {
      await requestMaker.deleteSubjectGroups(ids)
      dispatch(RefreshActions.refreshUserState())
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Succesfully deleted subject groups'
        })
      )
      handleClose(true)
    } catch (e) {
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Error - cannot delete subject group'
        })
      )
    }
  }, [ids])

  return (
    <div>
      <Dialog open onClose={handleClose}>
        <DialogTitle>Subject Group</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Are you sure to delete subject group${
              ids.length > 1 ? 's' : ''
            }?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose as any}>Cancel</Button>
          <Button
            onClick={() => {
              void onSubmit()
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default DeleteUserDialog
